module.exports = __webpack_public_path__ + "static/img/patientportal.58da07c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/patientportal.jpeg
// module id = /tlg
// module chunks = 7